import {
    Button, ExpansionPanel, FormControl, FormControlLabel,
    FormLabel, Grid, IconButton, Radio, RadioGroup, Tooltip
} from "@material-ui/core";
import { Add, Delete } from "@material-ui/icons";
import React from "react";
import { Field, FormSection } from "redux-form";
import { StyledExpansionPanelSummary } from "src/styles/form";
import { DateField, dateToTimestamp, FlexGridItem, FlexNumberField, FlexTextField, maxLength200, maxLength50, required, timestampToDate } from "./form_utility";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ConfirmDialog from "../../components/common/confirm-dialog.component";
import mainform from "./mainform";
import { PRIMARY_COLOR } from "src/constants/color";

class SupplyInfoForm extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public componentDidUpdate(prevProps: any) {
        // const { fields, isToasterVisible, disableForm } = this.props;
        // console.log("PROPS", this.props);
        // console.log("fields", fields);
    }

    private addEmptySupplyInfos = () => {
        const { fields } = this.props;
        fields.push({
            noOfVials: null,
            productName: '',
            lotNo: '',
            batchNo: '',
            manufacturer: '',
            dateReceived: null,
            expiryDate: null,
            tempExcursion: null,
            deviceInstalled: null
        });
    }

    private renderRadioField = ({ input, label, value, type, meta: { touched, error } }: any) => (
        <div>
            {/* { <input {...input} placeholder={label} type={type} />} */}
            <FormLabel className="label-text"><Radio {...input} />{label}</FormLabel>
            {touched && error && <span>{error}</span>}
        </div>
    );

    private openDialog = (index: any) => {
        this.setState((prevState: any) => ({
            [index]: true,
        }));
    };

    private closeConfirmDialog = (index: any) => {
        this.setState((prevState: any) => ({
            [index]: false,
        }));
    };

    private checkError = (index: any) => {
        const { mainForm, meta } = this.props;        
        if (mainForm && mainForm.mainForm.syncErrors &&
            mainForm.mainForm.syncErrors.supplyInfos &&
            mainForm.mainForm.syncErrors.supplyInfos.length) {
            if (meta.submitFailed && mainForm.mainForm.syncErrors.supplyInfos[index]
                && (mainForm.mainForm.syncErrors.supplyInfos[index].productName ||
                    mainForm.mainForm.syncErrors.supplyInfos[index].manufacturer)) {
                return "#cc0000";
            }
        }
        return PRIMARY_COLOR;
    }

    public render() {
        const { fields, disableForm } = this.props;
        return (
            <>
                <FlexGridItem xs={6}> <h4>Supply Info : </h4>
                    <div style={{ padding: "10px 5px" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.addEmptySupplyInfos}
                            disabled={disableForm}
                        >
                            Add
                            <Add />
                        </Button>
                    </div></FlexGridItem>
                <FlexGridItem xs={6}></FlexGridItem>
                {fields.map((member: any, index: any) => {
                    const summaryPanelColor = this.checkError(index);
                    return (
                        <FormSection key={index} name={member}>
                            <ConfirmDialog
                                open={this.state[index]}
                                close={() => this.closeConfirmDialog(index)}
                                title="Are you sure, you want to delete this section?"
                                content=""
                                ok={() => {
                                    this.setState((prevState: any) => ({
                                        [index]: false,
                                    }));
                                    fields.remove(index);
                                }}
                            />
                            <FlexGridItem style={{ paddingBottom: 0, paddingTop: 0 }} xs={12}>
                                <ExpansionPanel
                                    style={{ flex: 1, margin: "5px" }}
                                    defaultExpanded={true}
                                    disabled={disableForm}
                                >
                                    <StyledExpansionPanelSummary
                                        style={{ "background": summaryPanelColor }}
                                        expandIcon={<ExpandMoreIcon />}>
                                        <FlexGridItem xs={4}>
                                            <Tooltip title="Mark for deletion">
                                                <IconButton
                                                    onClick={() => this.openDialog(index)}>
                                                    <Delete />
                                                </IconButton>
                                            </Tooltip>
                                            <FormLabel className="label-text">Vaccine {index + 1}</FormLabel>
                                        </FlexGridItem>
                                    </StyledExpansionPanelSummary>
                                    <Grid container={true} spacing={2}
                                        style={{ flex: 1, padding: "24px" }}>
                                        <FlexGridItem xs={4}>
                                            <FlexNumberField
                                                name="noOfVials"
                                                label="No. of Vials"
                                                disabled={disableForm}
                                                inputProps={{ min: 0 }}
                                            />
                                        </FlexGridItem>
                                        <FlexGridItem xs={4}>
                                            <FlexTextField
                                                name="productName"
                                                label="Product Name"
                                                required={true}
                                                validate={[required, maxLength200]}
                                                disabled={disableForm}
                                            />
                                        </FlexGridItem>
                                        <FlexGridItem xs={4}>
                                            <FlexTextField
                                                name="lotNo"
                                                label="Lot No."
                                                disabled={disableForm}
                                            />
                                        </FlexGridItem>
                                        <FlexGridItem xs={4}>
                                            <FlexTextField
                                                name="batchNo"
                                                label="Batch No."
                                                disabled={disableForm}
                                            />
                                        </FlexGridItem>
                                        <FlexGridItem xs={4}>
                                            <FlexTextField
                                                name="manufacturer"
                                                label="Manufacturer"
                                                required={true}
                                                validate={[required, maxLength200]}
                                                disabled={disableForm}
                                            />
                                        </FlexGridItem>
                                        <FlexGridItem xs={4}>
                                            <DateField
                                                name="expiryDate"
                                                label="Expiry Date"
                                                format={timestampToDate}
                                                normalize={dateToTimestamp}
                                                disabled={disableForm}
                                            />
                                        </FlexGridItem>
                                        <FlexGridItem xs={4}>
                                            <DateField
                                                name="dateReceived"
                                                label="Date Received"
                                                format={timestampToDate}
                                                normalize={dateToTimestamp}
                                                disabled={disableForm}
                                            />
                                        </FlexGridItem>

                                        <FlexGridItem xs={8}>
                                            <Grid container={true} spacing={2}>
                                                <FlexGridItem xs={3}>
                                                    <FormLabel className="label-text">Temp Excursion :</FormLabel>
                                                </FlexGridItem>
                                                <FlexGridItem xs={4}>
                                                    <Field
                                                        name="isTempExcusrsion"
                                                        type="radio"
                                                        component={this.renderRadioField}
                                                        label="Yes"
                                                        value="1"
                                                    />
                                                    <Field
                                                        name="isTempExcusrsion"
                                                        type="radio"
                                                        component={this.renderRadioField}
                                                        label="No"
                                                        value="0"
                                                    />
                                                </FlexGridItem>
                                            </Grid>
                                        </FlexGridItem>
                                        <FlexGridItem xs={8}>
                                            <Grid container={true} spacing={2}>
                                                <FlexGridItem xs={5}>
                                                    <FormLabel className="label-text">
                                                        Data monitoring device installed?
                                                    </FormLabel>
                                                </FlexGridItem>
                                                <FlexGridItem xs={6}>
                                                    <Field
                                                        name="isDataMonitoringDeviceInstalled"
                                                        type="radio"
                                                        component={this.renderRadioField}
                                                        label="Yes"
                                                        value="1"
                                                    />
                                                    <Field
                                                        name="isDataMonitoringDeviceInstalled"
                                                        type="radio"
                                                        component={this.renderRadioField}
                                                        label="No"
                                                        value="0"
                                                    />
                                                </FlexGridItem>
                                            </Grid>
                                        </FlexGridItem>
                                    </Grid>
                                </ExpansionPanel>
                            </FlexGridItem>
                        </FormSection>
                    )
                })}

            </>
        );
    }
}

export default SupplyInfoForm;